import React, { useState } from "react";
import "./ConfirmDeleteModal.css";
import { X ,Trash2} from "lucide-react";

const ConfirmDeleteModal = ({ onClose, onConfirm, itemName }) => {
  const [inputValue, setInputValue] = useState("");

  const isConfirmEnabled = inputValue.trim().toUpperCase() === "DELETE";

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal">
        <div className="confirm-header">
          <h4>Delete Confirmation</h4>
          <X className="close-icon" size={20} onClick={onClose} />
        </div>

        <div className="confirm-body">
          <p>
            Are you sure you want to delete <strong>{itemName}</strong>? This action cannot be undone.
          </p>
          <p style={{ marginTop: "12px" }}>
            Please type <strong>DELETE</strong> to confirm.
          </p>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Type DELETE to confirm"
            className="delete-confirm-input"
          />
        </div>

        <div className="confirm-footer">
         <button className="confirm-cancel-btn" onClick={onClose}>
            <X size={14} style={{ marginRight: 6 }} /> Cancel
            </button>
            <button
            className="confirm-delete-btn"
            onClick={onConfirm}
            disabled={!isConfirmEnabled}
            >
            <Trash2 size={14} style={{ marginRight: 6 }} /> Delete
            </button>

        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
